import { useState, useEffect } from 'react';

/**
 * Tracks which dashboard tabs have been visited so their content can stay mounted
 * (hidden) instead of unmounting on every tab switch.
 */
export function useMountedDashboardTabs(activeTab, resetKey) {
  const [mountedTabs, setMountedTabs] = useState(() => new Set([activeTab]));

  useEffect(() => {
    setMountedTabs(new Set([activeTab]));
    // Only reset mounted tabs when the practice context changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  useEffect(() => {
    setMountedTabs((prev) => {
      if (prev.has(activeTab)) return prev;
      const next = new Set(prev);
      next.add(activeTab);
      return next;
    });
  }, [activeTab]);

  return mountedTabs;
}
